var map = {
	"./1.jpg": 5726,
	"./10.jpg": 3796,
	"./2.jpg": 1673,
	"./3.jpg": 60,
	"./4.jpg": 6375,
	"./5.jpg": 5210,
	"./6.jpg": 3061,
	"./7.jpg": 5448,
	"./8.jpg": 4563,
	"./9.jpg": 2950
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 628;